module.exports = __webpack_public_path__ + "img/arrow.9873f058.svg";